<div class="custom-ag-table">
    <div class="custom-ag-table-inner">
        <ag-grid-angular [id]="idString" [ngStyle]="style" class="ag-theme-alpine normal" [columnDefs]="columnDefs"
            [defaultColDef]="defaultColDef" [rowData]="rowData" [rowSelection]="rowSelection"
            [components]="frameworkComponents" [domLayout]="domLayout"
            (rowSelected)="onRowSelected($event)" (gridReady)="onGridReady($event)"
            (filterChanged)="onFilterChanged($event)" (sortChanged)="onSortChanged($event)" [gridOptions]="gridOptions"
            (rowDragEnd)="onRowDragEnd($event)"
            (rowDoubleClicked)="onRowDoubleClicked($event)"></ag-grid-angular>
        <div class="ag-grid-custom-pagination clearfix" *ngIf="!hidePagination">
            <app-custom-grid-pagination [idString]="idString" [selectedPageSizeValue]="selectedPageSizeValue"
                [paginationPageSizes]="paginationPageSizes" [hidePageSizeSelector]="hidePageSizeSelector" [startIndex]="startIndex"
                [endIndex]="endIndex" [totalRecordsCount]="totalRecordsCount" [currentPage]="currentPage"
                [totalPages]="totalPages" (onPaginationCompUpdate)="onPaginationCompUpdate($event)">
            </app-custom-grid-pagination>
        </div>
    </div>
</div>
